<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 09:10:08
 * @LastEditors: lau
 * @LastEditTime: 2022-08-23 15:32:50
-->

<!-- 根据根据券模版代码查询券模版信息接口内容 -->
<template>
	<div class="">
		<right-structure :Pdatas='infoData'>
			<pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
			<pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
		</right-structure>
	</div>
</template>

<script>
	import structure from "@/components/commonStructure"

	export default {
		name: '',
		components: {
			'right-structure': structure,
		},
		props: ['commonUrls'],
		data() {
			return {
				requestBody: {
					"carNos":["测123","测456"],
					"parkCodes":["XG","GX"]
				},
				responseCode: {
					"data": {
					},
					"message": "业务成功",
					"resultCode": 0,
					"status": 1
				},
				infoData: {
					explain: "第三方接入系统请求智慧停车开放平台查询优惠券列表",
					t_url: this.commonUrls.test + "getTraderCouponList",
					p_url: this.commonUrls.prod + "getTraderCouponList",
					precondition: "无",
					fitSystem: "VEMS传统停车场，云停车场",
					pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
					Q_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
							{info1: 'parkCodes',info2: '是',info3: 'JSONArray',info4: '车场编号列表'},
							{info1: 'carNos',info2: '否',info3: 'JSONArray',info4: '车牌号码列表'},
							{info1: 'traderCodes',info2: '否',info3: 'JSONArray',info4: '商家编码列表'},
							{info1: 'pageSize',info2: '否',info3: 'Integer',info4: '每页有多少条(默认10，最大1000)'},
							{info1: 'pageNum',info2: '否',info3: 'Integer',info4: '页码'},

					 ]
					}],
					R_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [ 
							{ info1: 'dataList', info2: '是', info3: 'dataList', info4: '数据列表' },

						]
					},{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [ 
							{ info1: 'id', info2: '是', info3: 'Long', info4: '用户优惠券id' },
                        { info1: 'carCode', info2: '否', info3: 'String', info4: '车牌号码' },
                        { info1: 'couponName', info2: '否', info3: 'String', info4: '优惠券名称' },
                        { info1: 'couponType', info2: '否', info3: 'Integer', info4: '优惠券类型' },
                        { info1: 'extraProperty', info2: '否', info3: 'String', info4: '额外属性' },
                        { info1: 'faceValue', info2: '否', info3: 'String', info4: '面值' },
                        { info1: 'grantMethod', info2: '否', info3: 'String', info4: '发放方式' },
                        { info1: 'grantTime', info2: '否', info3: 'String', info4: '发放时间' },
                        { info1: 'isCover', info2: '否', info3: 'Integer', info4: '是否可叠加适用' },
                        { info1: 'maxCoverNum', info2: '否', info3: 'Integer', info4: '最大叠加数' },
                        { info1: 'originalPrice', info2: '是', info3: 'Decimal', info4: '原价' },
                        { info1: 'realPrice', info2: '否', info3: 'Decimal', info4: '折扣价' },
                        { info1: 'parkCodes', info2: '否', info3: 'String', info4: '适用车场' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'serialNumber', info2: '否', info3: 'String', info4: '优惠券编码' },
                        { info1: 'status', info2: '否', info3: 'String', info4: '状态' },
                        { info1: 'syncStatus', info2: '否', info3: 'String', info4: '同步状态' },
                        { info1: 'userule', info2: '否', info3: 'String', info4: '使用规则' },
                        { info1: 'validFrom', info2: '否', info3: 'String', info4: '有效期开始时间' },
                        { info1: 'validTo', info2: '否', info3: 'String', info4: '有效期结束时间' },
                        { info1: 'privilegeDateText', info2: '否', info3: 'String', info4: '' },
												{info1: 'traderCode',info2: '否',info3: 'String',info4: '商家编码'},


						]
					}],
					codeStatus: [{
						titleName: null,
						tabledata: [{
							tableHead: '状态码',
							tdName: 'info1'
						}, {
							tableHead: '说明',
							tdName: 'info2'
						}],
						td: [{
							info1: '000110',
							info2: '失败',
						}, {
							info1: '00110000',
							info2: '失败',
						}, {
							info1: '110000',
							info2: '失败',
						}]
					}],
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/getTraderCouponList.vue